import { z } from 'zod';
import { LimitsSettingsSchema } from './limitsSettingsSchema';
import { TargetsSettingsSchema } from './targetsSchema';
import { AssetSimplificationSchema } from './assetSimplificationSchema';
import { SceneManipulationSettingsSchema } from './sceneManipulationSchema';
import { CompressionAndExportSchema } from './compressionAndExportSchema';
import { UvUnwrappingSchema } from '@/app/workflows/components/v6/operations/settings/form/schema/uvUnwrappingSchema';

export const CombinedSchema = z.object({
  id: z.number(),
  limits: LimitsSettingsSchema,
  targets: TargetsSettingsSchema,
  assetSimplification: AssetSimplificationSchema,
  sceneManipulation: SceneManipulationSettingsSchema,
  compressionAndExport: CompressionAndExportSchema,
  schema: z.string(),
  uvUnwrapping: UvUnwrappingSchema,
});

export type OperationsFormValues = z.infer<typeof CombinedSchema>;
